import * as React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const ARROW_IMG =
  "https://webimages.mongodb.com/_com_assets/cms/kz8dvz0d0cpi3up10-Vector%201%20(Stroke).svg?auto=format%252Ccompress"

const StyledLink = styled(Link)`
  width: max-content;
  ${({faux}) => faux && `
    color: #6e60f9;
    align-self: unset;

    @media screen and (min-width: 768px) {
      align-self: flex-end;
    }
  `}
  &:hover {
    img.arrow {
      cursor: pointer;
      transform: translate(4px, 0);
      transition: transform 0.2s;
    }
  }
  img.arrow {
    margin-left: 0.3em;
    transition: transform 0.2s;
  }
`

const CustomLink = ({ href, text, faux }) => {
  if (faux) {
    return (
      <StyledLink faux as="span">
        <span style={{ display: "flex", alignItems: "center" }}>
          <strong>{text}</strong>
          <img alt="arrow" className="arrow" src={ARROW_IMG} />
        </span>
      </StyledLink>
    )
  }
  if (href.startsWith("http")) {
    return (
      <StyledLink as="a" href={href} target="_blank" rel="noopener">
        <strong>{text}</strong>
        <img alt="arrow" className="arrow" src={ARROW_IMG} />
      </StyledLink>
    )
  } else {
    return (
      <StyledLink to={href}>
        <strong>{text}</strong>
        <img alt="arrow" className="arrow" src={ARROW_IMG} />
      </StyledLink>
    )
  }
}

export default CustomLink
